import { AdminVersionModelData } from './models/AdminVersionModel'
import { AdminVersionService } from './api/AdminVersionService'

const AdminVersionModule = {
  namespaced: true, // NameSpaced module
  state: AdminVersionModelData(),
  getters: {
    fetchFeVersion: state => state.feVersion,
    fetchBeVersion: state => state.beVersion
  },
  mutations: {
    setList (state, data) {
      state.feVersion = data.list.list
    }
  },
  actions: {

    /**
     * Get Frontend version
     */
    async getFeVersion ({ commit }, { resolve, reject }) {
      try {
        const response = await AdminVersionService.fetchFeVersion()
        resolve && resolve(response.data)
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get Backend version
     */
    async getBeVersion ({ commit }, { resolve, reject }) {
      try {
        const response = await AdminVersionService.fetchBeVersion()
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}

export default AdminVersionModule
